import produce from 'immer'
import Actions from '../actions'
import { routes, signUpStatus } from '../consts'

const initialState = {
  userSignup: {
    firstname: '',
    lastname: '',
    dob: '',
    phoneNumber: '',
    email: '',
    urlParams: '',
  },
  emailLoading: false,
  signupLoading: false,
  clickedInviteLink: false,
  pendingPatient: null,
  isSignupPhoneNumberLoading: false,
  isSignupPhoneNumberSuccess: false,
  isSignupPhoneNumberFailed: false,
  signupPhoneNumberErrorMessage: '',
  phoneNumberVerificationStatus: 'idle',
  isVerificationCodeValid: false,
  isVerificationCodeInvalid: false,
  signupErrorMessage: null,
  signupFormErrorMessage: null,
  hmoFirstLogin: {
    userId: null,
    smsAuthCode: null,
    ssnAuthCode: null,
  },
  signUpFlowPopup: null,
  quickSignUpFlow: false,
  prefillFieldsForSignup: null,
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.SIGNUP_EMAIL_REQUESTED: {
      draft.emailLoading = true
      draft.signupFormErrorMessage = null
      break
    }
    case Actions.CLASSIFY_USER_REQUESTED: {
      const {
        firstname,
        lastname,
        dateOfBirth,
        phoneNumber,
        email,
        urlParams,
      } = payload
      draft.userSignup.firstName = firstname
      draft.userSignup.lastName = lastname
      draft.userSignup.dob = dateOfBirth
      draft.userSignup.phoneNumber = phoneNumber
      draft.userSignup.email = email
      draft.userSignup.urlParams = urlParams
      draft.emailLoading = true
      draft.signupFormErrorMessage = null
      break
    }
    case Actions.CLASSIFY_USER_RECEIVED: {
      draft.emailLoading = false
      break
    }
    case Actions.PENDING_PATIENT_LASTDIGITS: {
      const { lastDigits } = payload
      draft.userSignup.lastDigits = lastDigits
      draft.userSignup.isInvited = true
      break
    }
    case Actions.SIGNUP_PANDING_PATIENT_RECEIVED: {
      const { pending_patient } = payload
      draft.pendingPatient = pending_patient
      draft.userSignup.phoneNumber = pending_patient.phone
      break
    }
    case Actions.FAMILY_INVITE_LINK_INFO_REQUESTED: {
      draft.clickedInviteLink = true
      break
    }
    case Actions.FAMILY_INVITE_LINK_INFO_RECEIVED: {
      const { pending_patient } = payload
      draft.pendingPatient = pending_patient
      draft.userSignup.lastDigits = pending_patient?.phone?.slice(-4)
      draft.userSignup.firstname = pending_patient?.firstname
      draft.userSignup.lastname = pending_patient?.lastname
      draft.userSignup.email = pending_patient?.email.toLowerCase()
      draft.userSignup.phoneNumber = pending_patient?.phone
      break
    }
    case Actions.FAMILY_INVITE_LINK_FINISHED: {
      draft.clickedInviteLink = false
      break
    }

    case Actions.SET_LOGIN_PHONE_NUMBER: {
      const { phoneNumber } = payload
      draft.userSignup.phoneNumber = phoneNumber
      break
    }

    case Actions.SIGNUP_EMAIL_RECEIVED: {
      const { email } = payload
      let lowerEmail = email.toLowerCase()
      draft.userSignup = { email: lowerEmail }
      draft.emailLoading = false

      break
    }
    case Actions.SIGNUP_EMAIL_FAILED: {
      draft.emailLoading = false
      draft.isSignupPhoneNumberSuccess = false
      break
    }

    case Actions.ONE_TIME_SMS_LOGIN: {
      draft.userSignup = { hasOnBoarded: false }
      draft.clickedInviteLink = false
      break
    }

    case Actions.OPERATION_FAILED: {
      const { signUpFormError, error } = payload
      draft.signupFormErrorMessage =
        signUpFormError?.error.message || error?.message
      draft.emailLoading = false
      draft.signupLoading = false
      break
    }

    case Actions.USER_ONBOARDED: {
      const { hasOnBoarded } = payload
      draft.userSignup = { hasOnBoarded }
      break
    }
    case Actions.RESET_PASSWORD_PRESSED:
    case Actions.CREATE_NEW_ACCOUNT_PRESSED: {
      draft.userSignup = { hasOnBoarded: false }
      break
    }
    case Actions.SIGNUP_PASSWORD_REQUESTED: {
      draft.signupLoading = true
      draft.signupErrorMessage = null
      break
    }
    case Actions.SIGNUP_RECEIVED: {
      draft.signupLoading = false
      break
    }
    case Actions.HMO_CONSENT_AGREEMENT_RECEIVED: {
      draft.prefillFieldsForSignup = null
      break
    }
    case Actions.INVALIDATE_COUNTRY_RECEIVED:
    case Actions.VALIDATE_COUNTRY_RECEIVED: {
      draft.signupLoading = false
      break
    }
    case Actions.SET_URL_PARAMS: {
      const { urlParams } = payload
      draft.urlParams = urlParams
      break
    }
    case Actions.SIGNUP_RECEIVED_FAILED: {
      const { error } = payload
      let errorMessage = ''
      if (error.body.password && error.body.password.length) {
        errorMessage = error.body.password
      } else {
        errorMessage = error?.body?.message
      }
      draft.signupLoading = false
      draft.signupErrorMessage = errorMessage

      break
    }
    case Actions.SIGNUP_PHONENUMBER_REQUESTED: {
      draft.isSignupPhoneNumberLoading = true
      draft.signupPhoneNumberErrorMessage = ''
      draft.isSignupPhoneNumberSuccess = false
      draft.isSignupPhoneNumberFailed = false

      break
    }
    case Actions.SIGNUP_PHONENUMBER_REQUESTED_SUCCESS: {
      draft.isSignupPhoneNumberLoading = false
      draft.signupPhoneNumberErrorMessage = ''
      draft.isSignupPhoneNumberSuccess = true
      draft.signupErrorMessage = null
      draft.isSignupPhoneNumberFailed = false
      break
    }
    case Actions.SIGNUP_PHONENUMBER_REQUESTED_FAILED: {
      draft.isSignupPhoneNumberLoading = false
      draft.signupPhoneNumberErrorMessage = payload.error.message
      draft.isSignupPhoneNumberSuccess = false
      draft.isSignupPhoneNumberFailed = true
      break
    }

    case Actions.SIGNUP_CODE_VERIFY_SUCCESS: {
      draft.isVerificationCodeValid = true
      draft.isVerificationCodeInvalid = false
      break
    }
    case Actions.SIGNUP_CODE_VERIFY_FAILED: {
      draft.isVerificationCodeValid = false
      draft.isVerificationCodeInvalid = true
      break
    }

    case Actions.SIGNUP_PHONE_NUMBER_VERIFICATION_PROCESS_COMPLETED: {
      draft.userSignup.firstname = payload.firstName
      draft.userSignup.lastname = payload.lastName
      draft.userSignup.dob = payload.dateOfBirth
      draft.userSignup.phoneNumber = payload.phoneNumber
      break
    }
    case Actions.HMO_FIRST_LOGIN_FLOW: {
      draft.isSignupPhoneNumberSuccess = true
      const { HashedUserId } = payload
      draft.hmoFirstLogin.userId = HashedUserId
      break
    }
    case Actions.PAYEMNT_REDIRECT_FLOW_USER_PROFILE_EXIST: {
      const { HashedUserId } = payload
      draft.hmoFirstLogin.userId = HashedUserId
      break
    }
    case Actions.VALID_SMS_RECIVED_HMO_FIRST_LOGIN: {
      const { auth_code } = payload
      draft.hmoFirstLogin.smsAuthCode = auth_code
      // draft.isVerificationCodeValid = true
      // draft.isVerificationCodeInvalid = false
      break
    }
    case Actions.QUICK_SIGNUP_RECEIVED: {
      const { auth_code, user, ssn_status, phone } = payload
      draft.isSignupPhoneNumberSuccess = ssn_status === signUpStatus.SSN_VALID
      draft.hmoFirstLogin.ssnAuthCode = auth_code
      draft.hmoFirstLogin.userId = user
      draft.hmoFirstLogin.phoneNumber = phone
      draft.quickSignUpFlow = true
      break
    }
    case Actions.VALID_SSN_RECIVED_HMO_FIRST_LOGIN: {
      const { auth_code } = payload
      draft.hmoFirstLogin.ssnAuthCode = auth_code
      break
    }
    case Actions.SHOW_SIGNUP_ERROR_POPUP: {
      const { text } = payload
      draft.signUpFlowPopup = text
      break
    }
    case Actions.CLOSE_SIGNUP_ERROR_POPUP: {
      draft.signUpFlowPopup = null
      break
    }
    case Actions.LOCATION_CHANGED: {
      const path = payload?.location?.pathname
      if (path === routes.SIGN_UP) {
        draft.emailLoading = false
        draft.isSignupPhoneNumberSuccess = false
        draft.isVerificationCodeValid = false
      }
      draft.signupErrorMessage = null
      draft.signupFormErrorMessage = null
      break
    }
    case Actions.GET_PREFILL_FIELDS_FOR_SIGNUP_FAILED: {
      draft.prefillFieldsForSignup = null
      break
    }
    case Actions.GET_PREFILL_FIELDS_FOR_SIGNUP_RECEIVED:
    case Actions.UNAUTENTICATED_PAYMENT_DETAILS_RECEIVED: {
      draft.prefillFieldsForSignup = payload?.prefillFields
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
